export default __webpack_public_path__ + "static/media/principal.ff75aede.png";